export default "__VITE_ASSET__DSXTxd4Z__"